import {ErrorMessage, General} from "../../types/Page";

export default {
  [General.TITLE]: 'Seite wurde nicht gefunden',
  [General.ERROR_TITLE]: 'Unerwarteter Fehler',

  [ErrorMessage.NOT_FOUND]: 'Wir konnten die angeforderte Seite leider nicht finden',
  [ErrorMessage.TRY_AGAIN]: 'Es ist ein unerwarteter Fehler aufgetreten. Sie können jetzt versuchen zurück zur Startseite zu gehen oder Sie setzen Ihre Bestellung zu einem späteren Zeitpunkt fort.'
}
